import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'store'

import notify from 'devextreme/ui/notify'

import { RootState } from 'slices'
import { loadSchema } from 'slices/schemas'

export const useIxJsonSchema = (name: string | null) => {
    const dispatch = useAppDispatch()
    const { schemas } = useSelector((state: RootState) => state.schemas)
    const [schema, setSchema] = useState<any>(null)

    useEffect(() => {
        if (name === null) { return }
        if (schemas[name] === undefined) {
            dispatch(loadSchema(name))
        }
    }, [dispatch, schemas, name])

    useEffect(() => {
        if (name === null) { setSchema({}); return }
        if (schemas[name] && schemas[name].status === 'fulfilled') {
            setSchema(schemas[name].schema)
        } else if (schemas[name] && schemas[name].status === 'rejected') {
            notify('Failed to load form\'s schema')
            setSchema({})
        }
    }, [schemas, name])

    return schema
}
